<template>
  <span
    class="px-4 work fadeinleft animation-duration-500 animation-iteration-1 flex align-items-center"
    :id="name"
    :style="{ top: topOption }"
  >
    <i :class="`pi pi-${icon} pr-2`"></i>
    <h3 class="m-0">{{ name }}</h3>
  </span>

  <div
    class="header fadeinright animation-duration-500 animation-iteration-1"
    :style="{ 'background-image': 'url(' + backgroundImage + ')' }"
  >
    <div class="mask flex align-items-center justify-conetnt-center">
      <span class="p-4 description mx-auto w-8">{{ description }}</span>
    </div>
  </div>
  <div class="flex justify-content-around px-4 projects">
    <div
      v-for="work in works"
      :key="work"
      class="w-full text-center"
      @click="link(work.link)"
    >
      <img
        v-if="work?.img"
        style="object-fit: cover"
        class="border-circle p-2"
        :src="work?.img"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Work",
  props: {
    name: String,
    description: String,
    works: [],
    icon: String,
    backgroundImage: String,
  },
  computed: {
    ...mapGetters({
      widthScreen: "getScreenWidth",
    }),
  },
  data() {
    return {
      topOption: "",
    };
  },
  methods: {
    setSize() {
      const screen = this.widthScreen >= 992;
      document.documentElement.style.setProperty(
        "--workSize",
        screen ? "2.5rem" : "2rem"
      );
      document.documentElement.style.setProperty(
        "--projectSize",
        screen ? "15rem" : "6rem"
      );
      document.documentElement.style.setProperty(
        "--descriptionWorkSize",
        screen ? "2rem" : "1.5rem"
      );
      this.topOption =
        document.getElementById(this.name)?.offsetHeight / 2 + "px" ||
        (screen ? "1.75rem" : "1rem");
    },
    link(link) {
      window.open(link, "_blanck");
    },
  },
  mounted() {
    this.setSize();
  },
  watch: {
    widthScreen() {
      this.setSize();
    },
  },
};
</script>
<style scoped lang="scss">
.work {
  position: relative;
  * {
    font-size: var(--workSize) !important;
  }
}
.description {
  position: relative;
  font-size: var(--descriptionWorkSize) !important;
}
.mask {
  height: inherit;
  background: rgba(0, 0, 0, 0.2);
}

.header {
  height: 50vh;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  //  background-attachment: fixed;
  //background-size:auto 60vh;
  background-position: center;
  z-index: 1;
}
.projects {
  position: relative;
  bottom: calc(var(--projectSize) / 2);
  img {
    height: var(--projectSize);
    width: var(--projectSize);
  }
}
@media screen and (max-width: 992px) {
  /* .projects {
    bottom: 2.5rem;
  }*/
}
</style>
